var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isLoading),expression:"isLoading",modifiers:{"fullscreen":true,"lock":true}}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }